import { render, staticRenderFns } from "./constitution.vue?vue&type=template&id=c161f714&scoped=true"
import script from "./constitution.vue?vue&type=script&lang=js"
export * from "./constitution.vue?vue&type=script&lang=js"
import style0 from "./constitution.vue?vue&type=style&index=0&id=c161f714&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c161f714",
  null
  
)

export default component.exports